import React from "react";
import { PropTypes } from "prop-types";

import { Input, Checkbox, Select, Form } from "antd";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const UserForm = ({ form, roles, newRecord }) => {
  const options =
    roles && roles.map((role) => <Option key={role._id}>{role.name}</Option>);

  return (
    <Form
      name="basic"
      initialValues={{ is_suspended: false }}
      className="gx-form-row0"
      ref={form}
      {...formItemLayout}
    >
      <Form.Item
        rules={[{ required: true, message: "This input is required!" }]}
        label="First Name"
        name="first_name"
      >
        <Input placeholder="First Name" />
      </Form.Item>
      <Form.Item
        rules={[{ required: true, message: "This input is required!" }]}
        label="Last Name"
        name="last_name"
      >
        <Input placeholder="Last Name" />
      </Form.Item>
      <Form.Item label="Email" name="email">
        <Input placeholder="email" disabled={!newRecord} />
      </Form.Item>
      {newRecord && (
        <Form.Item label="Default Password" name="password">
          <Input placeholder="password" type="password" />
        </Form.Item>
      )}
      {/* <Form.Item
        label="Contact"
        name="contact"
      >
        <Input placeholder="Contact" />
      </Form.Item> */}
      {/* <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        label="Gender"
        name="gender"
      >
        <Select placeholder="Select gender">
          <Option value="male">Male</Option>
          <Option value="female">Female</Option>
        </Select>
      </Form.Item> */}
      {/* <Form.Item
        label="Bio"
        name="bio"
      >
        <Input placeholder="Bio" />
      </Form.Item>
      <Form.Item
        label="Address"
        name="address"
      >
        <Input placeholder="Address" />
      </Form.Item> */}
      {/* <Form.Item
        label="Country"
        name="country"
      >
        <Input placeholder="Country" />
      </Form.Item>
      <Form.Item
        label="City"
        name="city"
      >
        <Input placeholder="City" />
      </Form.Item> */}
      <Form.Item label="Role" name="role">
        <Select
          allowClear
          style={{ width: "100%" }}
          placeholder="Please select role"
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {options}
        </Select>
      </Form.Item>
      {!newRecord && (
        <>
          <Form.Item
            label="Suspended"
            name="is_suspended"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            label="Verified"
            name="is_verified"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </>
      )}
      <Form.Item label="Approved" name="is_active" valuePropName="checked">
        <Checkbox />
      </Form.Item>
      <Form.Item label="Suspended" name="is_suspended" valuePropName="checked">
        <Checkbox />
      </Form.Item>
    </Form>
  );
};

UserForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  roles: PropTypes.arrayOf(PropTypes.shape({})),
  newRecord: PropTypes.bool,
};

UserForm.defaultProps = {
  form: {},
  roles: [],
  newRecord: false,
};

export default UserForm;
